import { render, staticRenderFns } from "./MobileHomeView.vue?vue&type=template&id=2d4aecb7&scoped=true"
import script from "./MobileHomeView.vue?vue&type=script&lang=js"
export * from "./MobileHomeView.vue?vue&type=script&lang=js"
import style0 from "./MobileHomeView.vue?vue&type=style&index=0&id=2d4aecb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4aecb7",
  null
  
)

export default component.exports